import React, { useState } from 'react';
import './ExternalServices.css';
import WorkLogModal from './WorkLogModal';
import Cooperants from './Cooperants';

export default function ExternalServices({
  externalServices,
  setExternalServices,
  setTotalExpense,
  closeShowWorkLogModal,
}) {
  const [cooperant, setCooperant] = useState('');
  const [serviceType, setServiceType] = useState('');
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [price, setPrice] = useState('');

  const [showCooperants, setShowCooperants] = useState(false);

  const handleExternalServiceAddition = () => {
    setExternalServices((prevValue) => [
      ...prevValue,
      { cooperant, serviceType, invoiceNumber, price: Number(price) },
    ]);

    setTotalExpense((prevTotal) => prevTotal + parseFloat(price));

    setCooperant('');
    setServiceType('');
    setInvoiceNumber('');
    setPrice('');
  };

  return (
    <div className="external-services">
      <div>
        <label htmlFor="cooperant" className="external-services-label">
          Kooperant
        </label>
        <input
          type="text"
          id="cooperant"
          className="external-service-field"
          value={cooperant}
          onChange={(e) => setCooperant(e.target.value)}
        />
        <label htmlFor="serviceType" className="external-services-label">
          Vrsta usluge/radova
        </label>
        <input
          type="text"
          id="serviceType"
          className="external-service-field"
          value={serviceType}
          onChange={(e) => setServiceType(e.target.value)}
        />
        <label htmlFor="invoiceNumber" className="external-services-label">
          Broj računa/fakture
        </label>
        <input
          type="text"
          id="invoiceNumber"
          className="external-service-field"
          value={invoiceNumber}
          onChange={(e) => setInvoiceNumber(e.target.value)}
        />
        <label htmlFor="price" className="external-services-label">
          Cijena
        </label>
        <input
          type="number"
          id="price"
          className="external-service-field"
          placeholder="0"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
        />

        {externalServices.length > 0 && (
          <div>
            <button
              type="button"
              className="external-services-button external-services-show-cooperants-button"
              onClick={() => setShowCooperants(true)}
            >
              Prikaži kooperante
            </button>
          </div>
        )}

        {showCooperants && (
          <WorkLogModal
            title={'Kooperanti'}
            bodyComponent={
              <Cooperants
                externalServices={externalServices}
                setExternalServices={setExternalServices}
                setTotalExpense={setTotalExpense}
                closeShowWorkLogModal={() => setShowCooperants(false)}
              />
            }
            closeShowWorkLogModal={() => setShowCooperants(false)}
          />
        )}

        <div className="external-services-buttons">
          <button
            type="button"
            className="external-services-button"
            onClick={closeShowWorkLogModal}
          >
            Zatvori
          </button>

          <button
            onClick={handleExternalServiceAddition}
            disabled={
              price <= 0 ||
              price === null ||
              cooperant === '' ||
              serviceType === ''
            }
            className="external-services-button external-services-add-button"
          >
            Dodaj
          </button>
        </div>
      </div>
    </div>
  );
}
